import { Info, TriangleAlert } from "lucide-react";

import type { OrderDetail } from "../lib/fulfillmentOrders";

/**
 * Above the order's actions on a tenant-owned order (L-1, W-1 in the concerns doc): staff's
 * changes reach the tenant's copy of the order only through order events, and only while the
 * tenant follows them, which Loot OS cannot see. With no `order_events_url` on the environment
 * the tenant hears only through the `GET /orders/changes` feed, if it reads it. A warning, never a
 * refusal. Nothing on Loot OS's own orders.
 */
export function OrderTenantEventsNotice({
  route,
  tenantName,
}: {
  route: OrderDetail["tenantEventRoute"];
  /** Null when the tenant's name did not resolve. */
  tenantName: string | null;
}) {
  if (!route) return null;
  const leadName = tenantName ?? "The tenant";
  const name = tenantName ?? "the tenant";
  if (!route.hasOrderEventsUrl) {
    return (
      <p className="flex items-start gap-2 rounded-md border border-destructive/40 bg-destructive/5 px-3 py-2 text-sm text-destructive">
        <TriangleAlert className="mt-0.5 size-4 shrink-0" />
        <span>
          {leadName} keeps its own copy of this order, but its environment has no order events URL.
          No change made here reaches {name} unless it reads the order changes feed, so its copy may
          fall behind.
        </span>
      </p>
    );
  }
  return (
    <p className="flex items-start gap-2 rounded-md border px-3 py-2 text-sm text-muted-foreground">
      <Info className="mt-0.5 size-4 shrink-0" />
      <span>
        {leadName} keeps its own copy of this order and applies changes made here only while it
        follows Loot OS's order events.
      </span>
    </p>
  );
}
